export {
  isClerkAPIResponseError,
  isClerkRuntimeError,
  isEmailLinkError,
  isKnownError,
  isMetamaskError,
  EmailLinkErrorCode,
  EmailLinkErrorCodeStatus,
} from '@clerk/shared/error';
